import React from "react"
import _ from "lodash"
import {
    Row, Col, Button, DropdownToggle,
    DropdownMenu,
    DropdownItem,
    UncontrolledDropdown,
} from "reactstrap"

function TitleWithBtn({ title, button, hasList, list }) {

    return (
        <Row>
            <Col className="align-self-center">
                <span className="h5 float-left">{title}</span>
            </Col>
            <Col>
                {hasList ?
                    <DropDownButton title={button.title} list={list} onClick={button.onClick} />
                    :
                    <>
                    {button? 
                        <Button className="float-right" color="info" onClick={button.onClick}>
                        {button.title}
                    </Button>
                    : <></>}
                    </>
                }
            </Col>
        </Row>
    )

}

export default TitleWithBtn

const DropDownButton = ({ title, list, onClick }) => (
    <UncontrolledDropdown>

        <DropdownToggle
            caret
            type="button"
            color="info"
            id="dropdownMenuButton"
            aria-haspopup={true}
            aria-expanded={false}
            data-toggle="dropdown"
            className="float-right"
        >
            {`${title} \t\t\t`}
        </DropdownToggle>

        <DropdownMenu aria-labelledby="dropdownMenuButton" right >
            {list.map(
                (item, index) => (
                    <DropdownItem
                        key={index}
                        id={item.key}
                        onClick={e => {
                            e.preventDefault()
                            onClick(item.key)
                        }}>
                        {item.name}
                    </DropdownItem>
                )
            )}
        </DropdownMenu>

    </UncontrolledDropdown>
)